import { Alert, Skeleton, SxProps, Typography } from '@mui/material';
import { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

type ChartLoadingGuardProps = {
  children: ReactNode;
  isLoading: boolean;
  error?: boolean;
  skeletonHeight?: number;
  sx?: SxProps;
};

export const ChartLoadingGuard = (
  props: ChartLoadingGuardProps,
): JSX.Element | ReactNode => {
  const {
    children,
    isLoading,
    error = false,
    skeletonHeight = 300,
    sx,
  } = props;
  const { t } = useTranslation();

  if (isLoading) {
    return <Skeleton variant="rectangular" height={skeletonHeight} sx={sx} />;
  }

  if (error) {
    return (
      <Alert severity="error" sx={sx}>
        <Typography>{t('chartLoadingGuard.errorMessage')}</Typography>
      </Alert>
    );
  }

  return children;
};
